// "Heeba Khan" -> HK, "ayaz.rashid@trialx.com" -> AR
export default function initials(text) {
  const words = (text || '').replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean);
  return words.slice(0, 2).map((word) => word[0].toUpperCase()).join('') || '?';
}
